import React, { useState, useEffect, useCallback } from 'react';
import Layout from '../components/Layout';
import api from '../api';

const TIPOS = { bomba: 'Bomba', gasodom: 'Gasodom', refineria: 'Refinería', rv_diesel: 'RV Diesel', sigma: 'Sigma', otro: 'Otro' };
const TIPO_COLORS = { bomba: '#1e4d8c', gasodom: '#0d6e8a', refineria: '#9a6b1a', rv_diesel: '#5b2d8a', sigma: '#1a6b3a', otro: '#666' };

const OrigenesCarga = ({ usuario, onLogout }) => {
  const [origenes, setOrigenes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editando, setEditando] = useState(null);
  const [error, setError] = useState('');
  const [form, setForm] = useState({ nombre: '', tipo: 'bomba' });

  const esAdmin = usuario?.rol === 'admin';

  const cargar = useCallback(async () => {
    setLoading(true);
    try { const res = await api.get('/origenes-carga'); setOrigenes(res.data); }
    catch { setError('Error cargando orígenes'); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { cargar(); }, [cargar]);

  const resetForm = () => { setForm({ nombre: '', tipo: 'bomba' }); setEditando(null); setShowForm(false); setError(''); };

  const abrirEditar = (o) => { setForm({ nombre: o.nombre, tipo: o.tipo }); setEditando(o.id); setShowForm(true); };

  const guardar = async (e) => {
    e.preventDefault(); setError('');
    try {
      editando ? await api.put(`/origenes-carga/${editando}`, form) : await api.post('/origenes-carga', form);
      resetForm(); cargar();
    } catch (err) { setError(err.response?.data?.detail || 'Error guardando origen'); }
  };

  const eliminar = async (id) => { if (!window.confirm('¿Desactivar este origen?')) return; try { await api.delete(`/origenes-carga/${id}`); cargar(); } catch { setError('Error'); } };

  const activos = origenes.filter(o => o.activo);

  return (
    <Layout usuario={usuario} onLogout={onLogout} title="Orígenes de Carga">
      <div style={S.headerRow}>
        <p style={S.subtitle}>Lugares donde los camiones cargan combustible</p>
        {esAdmin && <button style={S.btnAdd} onClick={() => setShowForm(true)}>+ Nuevo Origen</button>}
      </div>
      {error && <div style={S.error}>{error}</div>}
      {showForm && (
        <div style={S.formCard}>
          <h3 style={S.formTitle}>{editando ? 'Editar Origen' : 'Nuevo Origen de Carga'}</h3>
          <form onSubmit={guardar} style={S.form}>
            <div style={S.formGrid}>
              <div style={S.group}>
                <label style={S.label}>Nombre *</label>
                <input style={S.input} value={form.nombre} onChange={e => setForm({ ...form, nombre: e.target.value })} placeholder="Ej: Gasodom Norte" required />
              </div>
              <div style={S.group}>
                <label style={S.label}>Tipo *</label>
                <select style={S.input} value={form.tipo} onChange={e => setForm({ ...form, tipo: e.target.value })}>
                  {Object.entries(TIPOS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                </select>
              </div>
            </div>
            <div style={S.formBtns}>
              <button type="button" style={S.btnCancel} onClick={resetForm}>Cancelar</button>
              <button type="submit" style={S.btnSave}>{editando ? 'Guardar' : 'Crear Origen'}</button>
            </div>
          </form>
        </div>
      )}
      {loading ? <div style={S.loading}>Cargando...</div> : activos.length === 0 ? (
        <div style={S.empty}><div style={{ fontSize: '48px' }}>📍</div><p>No hay orígenes de carga registrados.</p></div>
      ) : (
        <div style={S.grid}>
          {activos.map(o => (
            <div key={o.id} style={S.card}>
              <div style={{ ...S.cardBadge, background: TIPO_COLORS[o.tipo] || '#666' }}>{TIPOS[o.tipo]}</div>
              <div style={S.cardNombre}>{o.nombre}</div>
              {esAdmin && (
                <div style={S.cardBtns}>
                  <button style={S.btnEdit} onClick={() => abrirEditar(o)}>✏️ Editar</button>
                  <button style={S.btnDel} onClick={() => eliminar(o.id)}>🗑️</button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </Layout>
  );
};

const S = {
  headerRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '12px' },
  subtitle: { color: '#888', fontSize: '13px', margin: 0 },
  btnAdd: { background: '#CC0000', color: '#fff', border: 'none', borderRadius: '8px', padding: '10px 18px', fontSize: '13px', fontWeight: '700', cursor: 'pointer' },
  error: { background: '#fff0f0', border: '1px solid #ffcccc', color: '#CC0000', padding: '10px 14px', borderRadius: '8px', fontSize: '13px', marginBottom: '16px' },
  formCard: { background: '#fff', borderRadius: '12px', padding: '24px', marginBottom: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', border: '1px solid #e0e0e0' },
  formTitle: { fontSize: '15px', fontWeight: '700', color: '#1a1a1a', margin: '0 0 16px' },
  form: { display: 'flex', flexDirection: 'column', gap: '16px' },
  formGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' },
  group: { display: 'flex', flexDirection: 'column', gap: '6px' },
  label: { fontSize: '12px', fontWeight: '600', color: '#555' },
  input: { padding: '10px 12px', borderRadius: '7px', border: '1.5px solid #e0e0e0', fontSize: '14px', outline: 'none', color: '#1a1a1a' },
  formBtns: { display: 'flex', gap: '10px', justifyContent: 'flex-end' },
  btnCancel: { padding: '10px 20px', borderRadius: '7px', border: '1.5px solid #e0e0e0', background: '#fff', color: '#666', fontSize: '13px', fontWeight: '600', cursor: 'pointer' },
  btnSave: { padding: '10px 20px', borderRadius: '7px', border: 'none', background: '#CC0000', color: '#fff', fontSize: '13px', fontWeight: '700', cursor: 'pointer' },
  loading: { textAlign: 'center', padding: '60px', color: '#666' },
  empty: { textAlign: 'center', padding: '60px', color: '#999', background: '#fff', borderRadius: '12px', border: '1px solid #e0e0e0' },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '14px' },
  card: { background: '#fff', borderRadius: '12px', border: '1px solid #e0e0e0', padding: '16px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' },
  cardBadge: { display: 'inline-block', color: '#fff', fontSize: '11px', fontWeight: '700', padding: '3px 10px', borderRadius: '20px', marginBottom: '10px' },
  cardNombre: { fontSize: '15px', fontWeight: '700', color: '#1a1a1a', marginBottom: '12px' },
  cardBtns: { display: 'flex', gap: '6px' },
  btnEdit: { flex: 1, padding: '7px', borderRadius: '6px', border: '1.5px solid #e0e0e0', background: '#fff', fontSize: '12px', fontWeight: '600', cursor: 'pointer', color: '#333' },
  btnDel: { padding: '7px 10px', borderRadius: '6px', border: 'none', background: '#fff0f0', cursor: 'pointer', fontSize: '14px' },
};

export default OrigenesCarga;
